
import React, { useState, useEffect } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import DeviceDetailsModal from '@/components/analytics/DeviceDetailsModal';
import AIAdvisoryTab from '@/components/analytics/AIAdvisoryTab';
import ConsumptionTab from '@/components/analytics/ConsumptionTab';
import PowerQualityTab from '@/components/analytics/PowerQualityTab';
import AlarmsTab from '@/components/analytics/AlarmsTab';
import { recentAlarms } from '@/data/energy-analytics-data';
import { Zap } from 'lucide-react';
import CompactLayout from '@/components/layout/CompactLayout';
import { useLocation } from 'react-router-dom';

interface LocationState {
  tab?: string;
  subTab?: string;
}

const Analytics = () => {
  const location = useLocation();
  const locationState = location.state as LocationState;
  
  const [tab, setTab] = useState(locationState?.tab || "aiAdvisory");
  const [selectedDevice, setSelectedDevice] = useState<null | typeof recentAlarms[0]>(null);
  const [showDeviceModal, setShowDeviceModal] = useState(false);

  // Pass subtab to AIAdvisoryTab if it exists in location state
  const subTab = locationState?.subTab;

  const handleDeviceClick = (device: typeof recentAlarms[0]) => {
    setSelectedDevice(device);
    setShowDeviceModal(true);
  };

  const closeDeviceModal = () => {
    setShowDeviceModal(false);
  };

  return (
    <CompactLayout>
      <Tabs defaultValue="aiAdvisory" value={tab} onValueChange={setTab} className="h-full flex flex-col">
        <div className="flex-none overflow-x-auto flex justify-center">
          <TabsList className="bg-white dark:bg-gray-800 p-1 rounded-lg border dark:border-gray-700">
            <TabsTrigger value="aiAdvisory" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">AI Advisory</TabsTrigger>
            <TabsTrigger value="consumption" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Consumption</TabsTrigger>
            <TabsTrigger value="quality" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Power Quality</TabsTrigger>
            <TabsTrigger value="alarms" className="px-3 py-1.5 md:px-4 md:py-2 text-sm">Alarms & Alerts</TabsTrigger>
          </TabsList>
        </div>
        
        <div className="flex-1 overflow-hidden mt-2">
          <TabsContent value="aiAdvisory" className="h-full overflow-auto m-0">
            <AIAdvisoryTab initialSubTab={subTab} />
          </TabsContent>
          
          <TabsContent value="consumption" className="h-full overflow-auto m-0">
            <ConsumptionTab />
          </TabsContent>
          
          <TabsContent value="quality" className="h-full overflow-auto m-0">
            <PowerQualityTab />
          </TabsContent>
          
          <TabsContent value="alarms" className="h-full overflow-auto m-0">
            <AlarmsTab onDeviceClick={handleDeviceClick} />
          </TabsContent>
        </div>
      </Tabs>
      
      <DeviceDetailsModal 
        isOpen={showDeviceModal}
        onClose={closeDeviceModal}
        device={selectedDevice}
      />
    </CompactLayout>
  );
};

export default Analytics;
